import {Injectable} from '@angular/core';
import {
  CheckParams,
  ConverterOutput,
  EricResponse,
  NachdigalService,
  SendRequest,
  Status,
  StatusEnum
} from '@nachdigal';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';

@Injectable()
export class EricService {

  constructor(private readonly nachdigalService: NachdigalService) {
  }

  private static getEricCheckBody(ericConverterData: ConverterOutput): CheckParams {
    return {
      eric_version: ericConverterData.ericVersion,
      eric_datenart: ericConverterData.ericDataType,
      eric_datenart_version: ericConverterData.ericDataTypeVersion,
      eric_xml: ericConverterData.ericXml
    } as CheckParams;
  }

  private static getEricSendBody(steuernummer: string,
                                 antragsteller: string,
                                 finanzamtnummer: number,
                                 converterOutput: ConverterOutput): SendRequest {
    return {
      tax_number: steuernummer,
      tax_office_id: finanzamtnummer,
      sender_description: antragsteller,
      eric_version: converterOutput.ericVersion,
      eric_data_type_version: converterOutput.ericDataTypeVersion,
      eric_xml: converterOutput.ericXml
    };
  }

  public check(taskId: string, converterOutput: ConverterOutput): Observable<EricResponse> {
    return this.nachdigalService.validateXml(taskId, EricService.getEricCheckBody(converterOutput));
  }

  public send(taskId: string,
              converterOutput: ConverterOutput,
              steuernummer: string,
              antragsteller: string,
              finanzamtnummer: number): Observable<Status> {
    const ericSendBody = EricService.getEricSendBody(steuernummer, antragsteller, finanzamtnummer, converterOutput);
    return this.nachdigalService.sendTask(taskId, ericSendBody).pipe(tap((status: Status) => {
        if (status.status === StatusEnum.SendingError) {
          throw Error(status.transfer_message);
        }
      })
    );
  }

}
